import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    submitButton: {
      marginBottom: 10,
      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        marginLeft: SMALL_MARGIN,
      },
    },
    field: {
      width: '100%',
      marginBottom: SMALL_MARGIN,
    },
  }),
);

export default useStyles;
